import { api } from '@api'
import { Scope } from '@utils'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export enum EventType {
  PRIVATE = 'private',
  COMMON = 'common',
  ALL = 'all',
}

export type CalendarEvent = {
  id: string
  title: string
  description: string
  startDateTime: string
  endDateTime?: string | null
  allDay?: boolean | null
  rrule?: string | null
  location: {
    place: string
    city?: string
    country?: string
    state?: string
    region?: string
  }
  type: EventType
  scope: string
  participantAccountIds: string[]
  /** Sent with one rendez-vous (GET /calendar-events/:id). */
  participants?: { id: string; avatarUrl: string | null; fullName: string; isGhost: boolean }[]
  /** Who organizes it (GET /calendar-events/:id). */
  organizer?: { id: string; avatarUrl: string | null; fullName: string } | null
  hasReminder: boolean
  descriptionAsReminder: boolean
  isDone?: boolean
  /** Organiser's account id; absent on an older API. */
  createdByAccountId?: string
  createdAt: string
  updatedAt: string
}

// Per request: the screens load every page (calendar dots, list by date), so
// fewer round trips than the API's 10.
const PAGE_SIZE = 100

const fetchCalendarEvents = async ({ pageParam = '0', search, scope, date }: FetchParams): Promise<PaginatedResponse<CalendarEvent>> => {
  let url = `/calendar-events?page=${pageParam}&limit=${PAGE_SIZE}`
  if (search) url += `&search=${search}`
  if (scope) url += `&scope=${scope}`
  if (date) url += `&date=${date}`
  
  const { data } = await api.get<PaginatedResponse<CalendarEvent>>(url)
  return data
}

export const usePaginateCalendarEvents = (
  { search, scope, date }: { search?: string, scope?: Scope, date?: string } = {},
  options?: { enabled?: boolean },
) => {
  return usePaginate<CalendarEvent>('calendar-events', fetchCalendarEvents, { search, scope, date }, options)
}

